import React from 'react'
import Label from '../Label/Label'
import { RadioProps } from './Radio.types'
import useInput from '../useInput'
import InputWrapper from '../InputWrapper/InputWrapper'
import uuid from 'uuidv4'

const Radio: React.FC<RadioProps> = (props) => {
    const { value, isDisabled, onChange, name, defaultChecked } = props
    const id = uuid()
    const classNames = () => {
        const c = ['r-radio-container']

        if (value) {
            c.push('r-state-checked')
        }
        if (isDisabled) {
            c.push('r-state-disabled')
        }

        return c.join(' ')
    }

    return (
        <div data-testid='Radio' className={classNames()}>
            <input id={id} type='radio' value={value} onChange={onChange} name={name} defaultChecked={defaultChecked} />
            <Label htmlFor={id}>{props.label}</Label>
        </div>
    )
}

export default Radio
